
import React, { useEffect, useMemo, useState } from "react";
import HighChartsColors from "./HIghChartsColors";
import { useDispatch, useSelector } from "react-redux";
import { customPreviewChartData } from "../../actions/auth";
import { Offcanvas } from "react-bootstrap";
// import drawOnChart from "./../../assets/images/drawOnChart.png";
import paintbrush from "../aserts/images/brush.png";
import { decryptData } from "../utils/EncriptionStore";
import { Box, CircularProgress, Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import "../globalCSS/previewhighcharts/previewhighcharts.css";
import styles from './SeverityCard.module.css';
import { useNavigate } from "react-router-dom";
import DefaultCreateDrillDown from '../DrillDownHandler/DefaultCreateDrillDown.jsx';
import UpdateDefaultCreateDrillDown from '../DrillDownHandler/UpdateDefaultCreateDrillDown.jsx';
import { saveMapDataForDrillDown, updateMapDataForDrillDown } from "../../actions/reportmanagement.js";

const CustomBox = ({
    customizationOptionsPreview,
    setCustomizationOptionsPreview,
    dragMe,
    setDragMe,
}) => {
    const dispatch = useDispatch();
    const history = useNavigate()
    const user = (() => {
        const encryptedData = localStorage.getItem("profile");
        return encryptedData ? decryptData(encryptedData) : null;
    })();



    const listOfTextSize = ["5px", "10px", "15px", "20px", "25px", "30px", "40px"];
    const listOfValueSize = ["5px", "10px", "15px", "20px", "25px", "30px", "40px"];

    const [legends, setLegends] = useState([]);
    const [legendsFromApi, setLegendsFromApi] = useState([]);
    const [totalLegends, setTotalLegends] = useState([]);
    const [defaultColors, setDefaultColors] = useState([]);
    const [loading, setLoading] = useState(false);
    const [buttonPosition, setButtonPosition] = useState({ top: "10%", left: "auto" });
    const [isTyping, setIsTyping] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [showUpdatePopup, setShowUpdatePopup] = useState(false);
    const [open, setOpen] = useState(false);


    const apiData = useSelector((state) => state?.auth);
    const CustomeDetailOfReport = JSON.parse(
        localStorage.getItem("customeDetailOfReport")
    );

    const PreviewchartData = apiData?.custom_preview_chart;
    /*new change */
    useEffect(() => {
        const fetchReport = async () => {
            setLoading(true); // Show loader
            await dispatch(
                customPreviewChartData({
                    report_name: CustomeDetailOfReport?.title,
                    report_type: CustomeDetailOfReport?.type,
                    chart_type: CustomeDetailOfReport?.chart_type,
                    query: CustomeDetailOfReport?.query,
                    email: user.user_email_id,
                    database_type: user.database_type,
                    connection_type: CustomeDetailOfReport?.connection_type,
                    schema: CustomeDetailOfReport?.schema,
                })
            );
            setLoading(false); // Hide loader after API call
        };

        fetchReport();
    }, []);

    //to set legends from data already stored in database
    useMemo(() => {
        if (CustomeDetailOfReport?.chart_colours) {
            let apiLegends = Object.keys(CustomeDetailOfReport.chart_colours);
            setLegendsFromApi(apiLegends);
        }
    }, []);

    const [data, setData] = useState();
    const [chartColoursFromJson, setChartColoursFromJson] = useState(defaultColors);

    // ...existing code...
    useEffect(() => {
        if (
            PreviewchartData?.xAxis &&
            Array.isArray(PreviewchartData?.xAxis) &&
            PreviewchartData?.xAxis.length > 0
        ) {
            // Assuming series[0].data contains severity keys and series[1].data contains their values
            const keys = PreviewchartData.series[0]?.data || [];
            const values = PreviewchartData.series[1]?.data || [];
            const response = {};
            keys.forEach((key, idx) => {
                response[key] = values[idx];
            });
            setData(response);
        }
    }, [PreviewchartData]);
    // ...existing code...

    //to set legends based on columns length returned by query
    useMemo(() => {
        setLegends([]);
        if (CustomeDetailOfReport?.chart_type === "custombox" && PreviewchartData?.len_col <= 2) {
            if (
                PreviewchartData?.xAxis &&
                Array.isArray(PreviewchartData?.xAxis) &&
                PreviewchartData?.xAxis.length > 0
            ) {
                PreviewchartData?.xAxis.forEach((item) => {
                    // Iterate through categories and add to legends
                    item?.categories?.forEach((category) => {
                        setLegends((prevLegends) => {
                            const nameAsString = String(category);
                            // Only add category if it's not already in legends
                            if (!prevLegends.includes(nameAsString)) {
                                return [...prevLegends, nameAsString];
                            }
                            return prevLegends;
                        });

                    });
                });
            }
        } else {
            if (PreviewchartData?.series && Array.isArray(PreviewchartData?.series)) {
                PreviewchartData?.series
                    .filter((series, index) => {
                        if (index === 0) {
                            return !series.data?.every((item) => typeof item === "string");
                        }
                        return true;
                    })
                    .forEach((seriesItem) => {
                        setLegends((prevLegends) => {
                            const nameAsString = String(seriesItem.name);
                            if (!prevLegends.includes(nameAsString)) {
                                return [...prevLegends, nameAsString];
                            }

                            return prevLegends;
                        });
                    });
            }
        }
    }, [PreviewchartData]);

    useMemo(() => {
        const allLegends = Array.from(new Set([...legends, ...legendsFromApi]));
        setTotalLegends(allLegends);
    }, [legends, legendsFromApi]);

    //to set default colors for legends
    useEffect(() => {
        // to get random colors from HighChartsColors.js
        const getRandomColors = (colors, count) => {
            let shuffledColors = [...colors].sort(() => 0.5 - Math.random());
            return shuffledColors.slice(0, count);
        };
        // to set default colors for legends
        let defaultColorsForJson =
            Array.isArray(totalLegends) && totalLegends?.length > 0
                ? getRandomColors(Object.values(HighChartsColors), totalLegends.length)
                : [];

        setDefaultColors(defaultColorsForJson);
    }, [totalLegends]);

    //to extract base legend key before bracket
    const getBaseLegendKey = (legend) => {
        const index = legend?.toString().indexOf("(");
        return index !== -1 ? legend.substring(0, index).trim() : legend;
    };

    //to map colors to each legend
    useMemo(() => {
        //function to map colors to legends
        const mapColorsToLegends = (chart_colours) => {
            const colorMapping = {};
            const baseColorMapping = {};

            //to set color for each legend
            totalLegends?.forEach((key) => {
                //obtain base key for each legend
                const baseKey = getBaseLegendKey(key);

                //if legend present as key in chart_colours object
                if (chart_colours[key]) {
                    colorMapping[key] = chart_colours[key];
                }

                //if a legend with  similar base key is not present in chart_colours object
                if (!baseColorMapping[baseKey]) {
                    baseColorMapping[baseKey] = chart_colours[key];
                }
            });

            return totalLegends.map((legend, index) => {
                //if exact legend is present in chart_colours object
                if (colorMapping[legend]) {
                    return colorMapping[legend];
                }
                //if one legend has similar base key as other legend
                const baseKey = getBaseLegendKey(legend);
                if (baseColorMapping[baseKey]) {
                    return baseColorMapping[baseKey];
                }
                //if no legend is present in chart_colours object
                return defaultColors[index % defaultColors.length];
            });
        };

        if (customizationOptionsPreview?.chart_colours) {
            setChartColoursFromJson(
                mapColorsToLegends(customizationOptionsPreview?.chart_colours)
            );
        } else if (CustomeDetailOfReport?.chart_colours) {
            setChartColoursFromJson(
                mapColorsToLegends(CustomeDetailOfReport?.chart_colours)
            );
        }
    }, [customizationOptionsPreview?.chart_colours, defaultColors, totalLegends]);



    function mapLegendsToColors(legends, customColors, defaultColors) {
        const colorMapping = {};
        const prefixColorMap = {};

        // Iterate through each legend
        legends.forEach((legend) => {
            // Extract the prefix (assuming prefix is everything before an underscore)
            const prefix = legend.split("(")[0];

            // Check if there is a color defined in customColors for this legend
            if (customColors && customColors[legend]) {
                // Assign the defined color to this legend and its prefixes
                colorMapping[legend] = customColors[legend];
                prefixColorMap[prefix] = customColors[legend]; // Store the color for the prefix
            } else if (prefixColorMap[prefix]) {
                // If no specific color, use the prefix's color if it exists
                colorMapping[legend] = prefixColorMap[prefix];
            } else {
                // If no colors defined, assign a default color based on index
                const defaultColorIndex =
                    Object.keys(colorMapping).length % defaultColors.length;
                colorMapping[legend] = defaultColors[defaultColorIndex];
            }
        });

        return colorMapping;
    }

    useEffect(() => {
        setCustomizationOptionsPreview({
            ...customizationOptionsPreview,
            chart_colours: mapLegendsToColors(
                totalLegends,
                CustomeDetailOfReport?.chart_colours,
                defaultColors
            ),
        });
    }, [totalLegends, defaultColors]);


    useEffect(() => {
        if (!isTyping && CustomeDetailOfReport) {
            const updates = {};
            if (CustomeDetailOfReport.chart_subtitle) updates.chart_subtitle = CustomeDetailOfReport.chart_subtitle;
            if (CustomeDetailOfReport.custombox_background_colour) updates.custombox_background_colour = CustomeDetailOfReport.custombox_background_colour;
            if (CustomeDetailOfReport.custombox_title_font_size) updates.custombox_title_font_size = CustomeDetailOfReport.custombox_title_font_size;
            if (CustomeDetailOfReport.custombox_value_font_size) updates.custombox_value_font_size = CustomeDetailOfReport.custombox_value_font_size;
            if (CustomeDetailOfReport.custombox_font_colour) updates.custombox_font_colour = CustomeDetailOfReport.custombox_font_colour;
            if (CustomeDetailOfReport.custombox_legend_font_colour) updates.custombox_legend_font_colour = CustomeDetailOfReport.custombox_legend_font_colour;
            if (CustomeDetailOfReport.custombox_legend_position) updates.custombox_legend_position = CustomeDetailOfReport.custombox_legend_position;
            if (CustomeDetailOfReport.display_title) updates.display_title = CustomeDetailOfReport.display_title;
            if (Object.keys(updates).length > 0) {
                setCustomizationOptionsPreview(prev => ({
                    ...prev,
                    ...updates
                }));
            }
        }
    }, [isTyping]);

    useEffect(() => {
        if (CustomeDetailOfReport?.enable_labels) {
            setCustomizationOptionsPreview((prev) => ({
                ...prev,
                enable_labels: CustomeDetailOfReport.enable_labels,
            }));
        }
    }, []);

    const handleChartSubtitleChange = (e) => {
        setIsTyping(true);
        setCustomizationOptionsPreview({
            ...customizationOptionsPreview,
            chart_subtitle: e.target.value,
        });
    };

   const handleChartDisplayTitleChange = (e) => {
        setIsTyping(true);
        setCustomizationOptionsPreview({
            ...customizationOptionsPreview,
            display_title: e.target.value,
        });
    };

    const handleColorChange = (legend, newColor) => {
        setCustomizationOptionsPreview((prevState) => {
            const updatedColors = { ...prevState.chart_colours };
            updatedColors[legend] = newColor;
            return {
                ...prevState,
                chart_colours: updatedColors,
            };
        });
    };

    const isEmptyObject = (obj) => !obj || Object.keys(obj).length === 0;


    const getHighlightValue = () => {
        if (!data) return '';
        if (data.Total !== undefined) return data.Total;
        // Sum all numeric values
        return Object.values(data).reduce((sum, val) => sum + (typeof val === 'number' ? val : 0), 0);
    };

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleMapUpdateDefaultDrilldownReport = () => {
        setOpen(false);
        setShowUpdatePopup(true);
    }

    const handleUpdateClosePopup = () => {
        setShowUpdatePopup(false);
    };
    const handleMapDashboardReport = () => {
        dispatch(saveMapDataForDrillDown({ type: "typesave" }))
        dispatch(updateMapDataForDrillDown({ type: "typeupdate" }))
        history('/mapreportstodashboard', { state: { newreportdetails: CustomeDetailOfReport, chartcoloursfromjson: totalLegends.filter((legend) => legends.includes(legend)) } });
    }

    const handleUpdateMapDashboardReport = () => {
        dispatch(saveMapDataForDrillDown({ type: "typesave" }))
        dispatch(updateMapDataForDrillDown({ type: "typeupdate" }))
        history('/updateinsightdashboard', { state: { newreportdetails: CustomeDetailOfReport, chartcoloursfromjson: totalLegends.filter((legend) => legends.includes(legend)) } });
    }

    const handleClose = () => {
        setOpen(false);
    };

    const handleMapDefaultDrilldownReport = () => {
        setOpen(false);
        setShowPopup(true);
    };

    const handleClosePopup = () => {
        setShowPopup(false);
    };

    const handleBackgroundColorChange = (newColor) => {
        setCustomizationOptionsPreview((prevState) => {
            return {
                ...prevState,
                custombox_background_colour: newColor,
            };
        });
    };

    const updateCustomizationOptions = (data) => {
        setCustomizationOptionsPreview((prev) => ({
            ...prev,
            ...data,
        }));
    };



    return (
        <div className="superHighChartsDisplayView">
            <DefaultCreateDrillDown open={showPopup} onClose={handleClosePopup} />
            <UpdateDefaultCreateDrillDown open={showUpdatePopup} onClose={handleUpdateClosePopup} />
            <div className="previewChartpage highChartsDisplayView">
                {loading ? (
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "300px" }}>
                        <CircularProgress />
                    </Box>
                ) : isEmptyObject(PreviewchartData) ? (
                    <Box sx={{ textAlign: "center", fontSize: "18px", fontWeight: "bold", color: "#4e5ff5", padding: "20px" }}>
                        No data found for this report
                    </Box>
                ) : (

                    <>
                        {/* <div className={styles.card} style={{ backgroundColor: `${customizationOptionsPreview?.custombox_background_colour}` }}>
                            <div className={styles.header} style={{ color: `${customizationOptionsPreview?.custombox_font_colour}` }}>
                                <span style={{ fontSize: `${customizationOptionsPreview?.custombox_title_font_size}` }}>{CustomeDetailOfReport?.title}</span>
                            </div>
                            <div className={styles.highlightWrapper}>
                                <span className={styles.highlightValue} style={{ color: `${customizationOptionsPreview?.custombox_font_colour}`, fontSize: `${customizationOptionsPreview?.custombox_value_font_size}` }}>{getHighlightValue()}</span>
                                <span className={styles.highlightLabel}>
                                    {customizationOptionsPreview?.chart_subtitle || ""}
                                </span>
                            </div>
                            <div className={styles.legend}>
                                {totalLegends
                                    .filter((legend) => legends.includes(legend)).map((key, index) => (
                                        <div key={key} className={styles.legendItem}>
                                            <span
                                                className={styles.badge}
                                                style={{ backgroundColor: customizationOptionsPreview?.chart_colours[key] }}
                                            >
                                                {data?.[key]}
                                            </span>
                                            <span style={{ color: customizationOptionsPreview?.custombox_legend_font_colour }}>{key}</span>
                                        </div>
                                    ))}
                            </div>
                        </div> */}
                        <div className={styles.card} style={{ backgroundColor: customizationOptionsPreview?.custombox_background_colour }}>
                            <div className={styles.header} style={{ color: customizationOptionsPreview?.custombox_font_colour }}>
                                <span style={{ fontSize: customizationOptionsPreview?.custombox_title_font_size }}>{CustomeDetailOfReport?.title}</span>
                            </div>
                            {customizationOptionsPreview?.custombox_legend_position === "vertical" ? (
                                <div className={styles.verticalLayout}>
                                    <div className={styles.highlightWrapper}>
                                        <span className={styles.highlightValue} style={{ color: customizationOptionsPreview?.custombox_font_colour, fontSize: customizationOptionsPreview?.custombox_value_font_size }}>{getHighlightValue()}</span>
                                        <span className={styles.highlightLabel}>
                                            {customizationOptionsPreview?.chart_subtitle || ""}
                                        </span>
                                    </div>
                                    <div className={styles.verticalLegend}>
                                        {totalLegends
                                            .filter((legend) => legends.includes(legend)).map((key, index) => (
                                                <div key={key} className={styles.legendItemVertical}>
                                                    <span
                                                        className={styles.badge}
                                                        style={{ backgroundColor: customizationOptionsPreview?.chart_colours[key] }}
                                                    >
                                                        {data?.[key]}
                                                    </span>
                                                    <span style={{ color: customizationOptionsPreview?.custombox_legend_font_colour }}>{key}</span>
                                                </div>
                                            ))}
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className={styles.highlightWrapper}>
                                        <span className={styles.highlightValue} style={{ color: customizationOptionsPreview?.custombox_font_colour, fontSize: customizationOptionsPreview?.custombox_value_font_size }}>{getHighlightValue()}</span>
                                        <span className={styles.highlightLabel}>
                                            {customizationOptionsPreview?.chart_subtitle || ""}
                                        </span>
                                    </div>
                                    <div className={styles.legend}>
                                        {totalLegends
                                            .filter((legend) => legends.includes(legend)).map((key, index) => (
                                                <div key={key} className={styles.legendItem}>
                                                    <span
                                                        className={styles.badge}
                                                        style={{ backgroundColor: customizationOptionsPreview?.chart_colours[key] }}
                                                    >
                                                        {data?.[key]}
                                                    </span>
                                                    <span style={{ color: customizationOptionsPreview?.custombox_legend_font_colour }}>{key}</span>
                                                </div>
                                            ))}
                                    </div>
                                </>

                            )}
                        </div>
                    </>
                )}
            </div>

            <div
                className="draggable-toggle-button"
                onClick={() => setDragMe(!dragMe)}
                style={{
                    position: "absolute",
                    top: buttonPosition.top,
                    left: buttonPosition.left,
                }}
            >
                <img
                    src={paintbrush}
                    alt="paintbrush"
                    className="customize-chart-icon"
                />
            </div>
            <Offcanvas
                className="custom-color-super-container"
                show={dragMe}
                onHide={() => setDragMe(!dragMe)}
                placement="end"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Chart Configuration</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body style={{ minWidth: "300px" }}>
                    {(CustomeDetailOfReport?.enable_drilldown === "yes") && (
                        CustomeDetailOfReport?.report_id && CustomeDetailOfReport?.report_id !== "" ? (
                            <div className="add-drill-down-option" style={{ marginBottom: "10px" }}>

                                <Button variant="outlined" onClick={handleClickOpen}
                                    sx={{
                                        backgroundColor: '#1d5dfb', color: 'white', borderRadius: '7px', border: 'none', '&:hover': {
                                            backgroundColor: '#174de6',
                                        },
                                    }}
                                >
                                    Update DrillDown
                                </Button>
                                <Dialog
                                    open={open}
                                    onClose={handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle id="alert-dialog-title">
                                        {"Select Drill Down Mode?"}
                                    </DialogTitle>
                                    <DialogActions>
                                        {CustomeDetailOfReport?.enable_drilldown === "yes" && CustomeDetailOfReport?.drilldown_type === "default" ? (<Button onClick={handleMapUpdateDefaultDrilldownReport}>
                                            Update Details Report Map
                                        </Button>) : <Button onClick={handleMapDefaultDrilldownReport}>
                                            Details Report Map
                                        </Button>}

                                        {CustomeDetailOfReport?.enable_drilldown === "yes" && CustomeDetailOfReport?.drilldown_type === "dashboard" ? (<Button onClick={handleUpdateMapDashboardReport} autoFocus>
                                            Update Dashboard Map
                                        </Button>) : <Button onClick={handleMapDashboardReport} autoFocus>
                                            Dashboard Map
                                        </Button>}
                                    </DialogActions>
                                </Dialog>
                            </div>
                        ) : (
                            <div className="update-drill-down-option" style={{ marginBottom: "10px" }}>
                                <Button variant="outlined" onClick={handleClickOpen}
                                    sx={{
                                        backgroundColor: '#1d5dfb', color: 'white', borderRadius: '7px', border: 'none', '&:hover': {
                                            backgroundColor: '#174de6',
                                        },
                                    }}
                                >
                                    Add DrillDown
                                </Button>
                                <Dialog
                                    open={open}
                                    onClose={handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                                >
                                    <DialogTitle id="alert-dialog-title">
                                        {"Select Drill Down Mode?"}
                                    </DialogTitle>
                                    <DialogActions>
                                        {CustomeDetailOfReport?.enable_drilldown === "yes" ? (<Button onClick={handleMapDefaultDrilldownReport}>
                                            Details Report Map
                                        </Button>) : null}
                                        {CustomeDetailOfReport?.enable_drilldown === "yes" ? (<Button onClick={handleMapDashboardReport} autoFocus>
                                            Dashboard Map
                                        </Button>) : null}
                                    </DialogActions>
                                </Dialog>
                            </div>
                        )
                    )}
                    <div className="custom-color-input">
                        <div className="custom-color-show">
                            <input
                                type="color"
                                value={
                                    customizationOptionsPreview?.custombox_background_colour
                                }
                                onChange={(e) =>
                                    handleBackgroundColorChange(e.target.value)
                                }
                            />
                        </div>
                        <div className="custom-color-label">
                            <label style={{ cursor: "pointer" }} >Background Color</label>
                        </div>
                    </div>
                    <div className="custom-color-input">
                        <div className="custom-color-show">
                            <input
                                type="color"
                                className="color-picker"
                                value={customizationOptionsPreview?.custombox_font_colour}
                                onChange={(e) =>
                                    updateCustomizationOptions({ custombox_font_colour: e.target.value })
                                }
                            />
                        </div>
                        <div className="custom-color-label">
                            <label style={{ cursor: "pointer" }} >Font Color</label>
                        </div>
                    </div>
                    <div className="custom-color-input">
                        <div className="custom-color-show">
                            <input
                                type="color"
                                className="color-picker"
                                value={customizationOptionsPreview?.custombox_legend_font_colour}
                                onChange={(e) =>
                                    updateCustomizationOptions({ custombox_legend_font_colour: e.target.value })
                                }
                            />
                        </div>
                        <div className="custom-color-label">
                            <label style={{ cursor: "pointer" }} >Legend Font Color</label>
                        </div>
                    </div>

                    <div className={styles.settings_section}>
                        <h3 className={styles.settings_heading}>Typography</h3>
                        <label>Title Font Size:</label>
                        <select
                            className={styles.settings_select}
                            value={customizationOptionsPreview?.custombox_title_font_size}
                            onChange={(e) =>
                                updateCustomizationOptions({ custombox_title_font_size: e.target.value })
                            }
                        >
                            <option value="" disabled>
                                Title Font Size
                            </option>
                            {listOfTextSize.map((size) => (
                                <option key={size} value={size}>
                                    {size}
                                </option>
                            ))}
                        </select>
                        <label>Legend Position:</label>
                        <select
                            className={styles.settings_select}
                            value={customizationOptionsPreview?.custombox_legend_position}
                            onChange={(e) =>
                                updateCustomizationOptions({ custombox_legend_position: e.target.value })
                            }
                        >
                            <option value="" disabled>
                                Legend Position
                            </option>
                            {["horizontal", "vertical"].map((size) => (
                                <option key={size} value={size}>
                                    {size}
                                </option>
                            ))}
                        </select>
                        <label>Value Font Size:</label>
                        <select
                            className={styles.settings_select}
                            value={customizationOptionsPreview?.custombox_value_font_size}
                            onChange={(e) =>
                                updateCustomizationOptions({ custombox_value_font_size: e.target.value })
                            }
                        >
                            <option value="" disabled>
                                Value Font Size
                            </option>
                            {listOfValueSize.map((size) => (
                                <option key={size} value={size}>
                                    {size}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="add-chart-subtitle">
                        <label className="chart-subtitle-label">Chart Subtitle</label>
                        <input
                            className="chart-subtitle-input form-control"
                            type="text"
                            maxLength={40}
                            value={customizationOptionsPreview?.chart_subtitle}
                            onChange={handleChartSubtitleChange}
                        />
                    </div>
                    <div className="add-chart-subtitle">
                        <label className="chart-subtitle-label">Display Title</label>
                        <input
                            className="chart-subtitle-input form-control"
                            type="text"
                            maxLength={40}
                            value={customizationOptionsPreview?.display_title}
                            onChange={handleChartDisplayTitleChange}
                        />
                    </div>
                    <div className="highCharts-color-configurationview">
                        {totalLegends
                            .filter((legend) => legends.includes(legend))
                            .map((legend, index) => (
                                <div key={index} className="custom-color-input">
                                    <div className="custom-color-show">
                                        <input
                                            type="color"
                                            value={
                                                customizationOptionsPreview?.chart_colours[legend]
                                            }
                                            onChange={(e) =>
                                                handleColorChange(legend, e.target.value)
                                            }
                                        />
                                    </div>
                                    <div className="custom-color-label">
                                        <label style={{ cursor: "pointer" }} title={legend} >{legend}</label>
                                    </div>
                                </div>
                            ))}
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </div>
    );
};

export default CustomBox;

